import { useRef } from 'react';
import { GridDistortion } from './GridDistortion.jsx';
import { ResponsivePicture } from './ResponsivePicture.jsx';

/**
 * Hero shell.
 *  - Default: full-bleed background + centered title (Home).
 *  - portal=true: bounded image card + side-by-side text — the card is the
 *    view-transition landing site so the morph from Home's feature-visual is
 *    accurate (no full-screen scale-up).
 */
export function Hero({
  bgSrc,
  bgAlt = '',
  distortion = false,
  compact = false,
  extraClass = '',
  topLabel,
  children,
  scrollHint = true,
  portalName,
  portal = false,
}) {
  const heroRef = useRef(null);

  if (portal) {
    return (
      <header ref={heroRef} className={`hero hero--portal ${extraClass}`.trim()}>
        <div className="hero-content">
          {topLabel ? <div className="hero-top-label">{topLabel}</div> : null}
          {children}
        </div>
        <div className="hero-portal-media">
          <ResponsivePicture
            src={bgSrc}
            alt={bgAlt}
            sizes="(max-width: 720px) 100vw, 50vw"
            eager
            viewTransitionName={portalName}
          />
        </div>
        {scrollHint ? (
          <div className="hero-scroll" data-hero-delay="1.8">
            Scroll
          </div>
        ) : null}
      </header>
    );
  }

  return (
    <header ref={heroRef} className={`hero ${compact ? 'hero-compact' : ''} ${extraClass}`.trim()}>
      {distortion ? (
        <GridDistortion src={bgSrc} alt={bgAlt} heroRef={heroRef} />
      ) : (
        <div className="hero-bg">
          <ResponsivePicture
            src={bgSrc}
            alt={bgAlt}
            sizes="100vw"
            eager
            viewTransitionName={portalName}
          />
        </div>
      )}
      {topLabel ? <div className="hero-top-label">{topLabel}</div> : null}
      <div className="hero-content">{children}</div>
      {scrollHint ? (
        <div className="hero-scroll" data-hero-delay="1.8">
          Scroll
        </div>
      ) : null}
    </header>
  );
}
